import React from "react";
import QuestionSection from "./QuestionSection";
import { connect } from "react-redux";

class QuestionSections extends React.Component {

	render() {

		let sections = this.props.sections[this.props.form].filter(section => section.form === this.props.form).map((section, index) => {
			return (
				<QuestionSection
					testObj={this.props.testObj}
					key={section.id}
					section={section}
					qsi={index + 1}
				/>
			)
		});

		return (
			<div className="questionnaire__sections">
				{sections}
			</div>
		)
	}

}

export default connect(state => ({ sections: state.formSections }))(QuestionSections);


// WEBPACK FOOTER //
// ./src/modules/form/view.1/QuestionSections.js